import { TextParallaxContentExample } from "../components/TextParallaxContentExample";

export function Home() {
  return (
    <>
      <TextParallaxContentExample />
    </>
  );
}
